import { render, staticRenderFns } from "./MatchOverview.vue?vue&type=template&id=7311c5d2&scoped=true&lang=pug&"
import script from "./MatchOverview.vue?vue&type=script&lang=js&"
export * from "./MatchOverview.vue?vue&type=script&lang=js&"
import style0 from "./MatchOverview.vue?vue&type=style&index=0&id=7311c5d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7311c5d2",
  null
  
)

export default component.exports